module.exports = __webpack_public_path__ + "img/electric-mining-drill-N-drill-received-shadow.df53d137.png";